<template>
  <v-tooltip v-if="enabled" v-bind="tooltipBind">
    <template v-if="$slots.activator" #activator="slotProps">
      <slot name="activator" v-bind="slotProps" />
    </template>
    <div class="home-wage-tooltip-content">
      <span v-if="showAdminBadge" class="home-wage-tooltip-admin-badge">관리자전용</span>
      <div class="home-wage-tooltip-body">
        <slot>
          <span v-if="fallbackText">{{ fallbackText }}</span>
        </slot>
      </div>
    </div>
  </v-tooltip>
  <slot v-else-if="$slots.activator" name="activator" :props="{}" />
</template>

<script setup lang="ts">
import { computed, inject, useAttrs } from 'vue';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    /** true면 기관회원(고객)에게도 툴팁 표시 — 관리자전용 뱃지 없음 */
    memberVisible?: boolean;
  }>(),
  { memberVisible: false },
);

const attrs = useAttrs();

const injected = inject<{ value: boolean } | boolean>('showWageTooltips', true);

const adminTooltipsEnabled = computed(() => {
  if (typeof injected === 'boolean') return injected;
  if (injected && typeof injected === 'object' && 'value' in injected) return injected.value;
  return true;
});

const enabled = computed(() => props.memberVisible || adminTooltipsEnabled.value);

const showAdminBadge = computed(() => enabled.value && !props.memberVisible);

const tooltipBind = computed(() => {
  const { text, ...rest } = attrs as Record<string, unknown>;
  return rest;
});

const fallbackText = computed(() => {
  const text = attrs.text;
  return typeof text === 'string' ? text : '';
});
</script>
